import React, { useContext } from 'react';
import Map from 'sub_components/Common/Map';
import styled from 'styled-components';
import { ServiceRequestContext } from 'context/ServiceRequestContext';
import { ILA_HUTS } from 'utils/CommonConstants';
import ScrollView from 'sub_components/Common/BloxScrollViewNew';

const CDN_URL = process.env.REACT_APP_CDN_URL;

const AtlantaDefault = `${CDN_URL}support/ticketing/location-atlanta-icon-default-lg.svg`;
const AtlantaSelected = `${CDN_URL}support/ticketing/location-atlanta-selected-lg.svg`;
const BirminghamDefault = `${CDN_URL}support/ticketing/location-birmingham-building-default-lg.svg`;
const BirminghamSelected = `${CDN_URL}support/ticketing/location-birmingham-selected-lg.svg`;
const ChattanoogaDefault = `${CDN_URL}common/chattanooga-building-lg.svg`;
const ChattanoogaSelected = `${CDN_URL}support/ticketing/location-chattanooga-selected-lg.svg`;
const HuntsvilleDefault = `${CDN_URL}support/ticketing/location-huntsville-building-default-lg.svg`;
const HuntsvilleSelected = `${CDN_URL}support/ticketing/location-huntsville-selected-lg.svg`;

const LocationScreenStyle = styled.div`
	width: 100%;
	height: 160px;

	.map-wrapper {
		position: absolute;
		left: 17px;
	}
	.locations-wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-wrap: wrap;
	}
	.ScrollbarsCustom-Track {
		right: -10px !important;
		top: 0px !important;
	}
	.ScrollbarsCustom-ThumbY {
		background-color: ${props => props.theme.support} !important;
		width: 6px !important;
	}
	.ScrollbarsCustom-TrackY:before {
		border-left: none;
	}
	.ScrollbarsCustom-TrackY {
		background-color: ${props => props.theme.Cool_Gray_Light_2} !important;
		box-shadow: -1px -1px 1.5px ${props => props.theme.Cool_Gray_Light_3} inset,
			1px 1px 1.5px ${props => props.theme.Cool_Gray_Med_2} inset;
		width: 6px !important;
	}

	.location-selection {
		width: 100px;
		height: 88px;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;

		cursor: pointer;
		img {
			width: 55px;
			height: 54px;
		}
	}

	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		height: 220px;
		.map-wrapper {
			left: 47px;
		}
		.location-selection {
			width: 130px;
			height: 128px;

			img {
				width: 80px;
				height: 75px;
			}
		}
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
		height: 385px;
		.map-wrapper {
			left: 60px;
		}
		.location-selection {
			width: 180px;
			height: 208px;

			img {
				width: 100px;
				height: 110px;
				margin-left: GetSize(5);
			}
		}
	}
`;

function onMouseEnter(id) {
	const icon = document.getElementById(id);

	if (id === 'atlanta') {
		icon.src = AtlantaSelected;
	} else if (id === 'BHR') {
		icon.src = BirminghamSelected;
	} else if (id === 'CHA') {
		icon.src = ChattanoogaSelected;
	} else {
		icon.src = BirminghamSelected;
	}
}
function onMouseLeave(id, typeIcon) {
	const icon = document.getElementById(id);
	icon.src = typeIcon;
}

function getLocationIconSelected() {
	return BirminghamSelected;
}

function getLocationIcon(tag, inputs) {
	const selected = inputs.location;

	const atlantaIcon = selected === 'atlanta' ? AtlantaSelected : AtlantaDefault;
	const birminghamIcon = selected === 'birmingham' ? BirminghamSelected : BirminghamDefault;
	const chattanoogaIcon = selected === 'chattanooga' ? ChattanoogaSelected : ChattanoogaDefault;
	const huntsvilleIcon = selected === 'huntsville' ? HuntsvilleSelected : HuntsvilleDefault;
	switch (tag) {
		case 'ATL':
			return atlantaIcon;
		case 'BHM':
			return birminghamIcon;
		case 'CHA':
			return chattanoogaIcon;
		case 'HSV':
			return huntsvilleIcon;

		default:
			return birminghamIcon;
	}
}

export const LocationScreen = ({ services }) => {
	const { inputs, change } = useContext(ServiceRequestContext);
	const ila = inputs?.type === 'ila' ? true : false;
	function onLocationChange(location) {
		change({ target: { name: 'location', value: location } });
	}

	function returnLocation(hut) {
		const lowerName = hut?.id;
		const locationIcon =
			inputs?.location === lowerName
				? getLocationIconSelected(hut?.id, inputs)
				: getLocationIcon(hut?.id, inputs);

		return (
			<div
				className='location-selection'
				onClick={() => onLocationChange(hut?.id)}
				onMouseEnter={() => onMouseEnter(lowerName)}
				onMouseLeave={() => onMouseLeave(lowerName, locationIcon)}
				data-cy={hut?.id}
			>
				<img src={locationIcon} id={lowerName} />
				<div className='title heading76'>{`${hut?.city} ,${hut?.state}`}</div>
			</div>
		);
	}

	return (
		<LocationScreenStyle className='location-screen'>
			{!ila && <Map services={services} onChange={onLocationChange} location={inputs.location} />}
			{ila && (
				<ScrollView>
					<div className='locations-wrapper'>
						{ILA_HUTS.map(hut => {
							return returnLocation(hut);
						})}
					</div>
				</ScrollView>
			)}
		</LocationScreenStyle>
	);
};
